import React from "react";

function Empowerment() {
  const empower = [
    {
      id: 1,
      src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1694004691/jyoti_tsy305.jpg",
      speaker: "JYOTI PATTNAIK ",
      designation: "Public Speaker",
      workshop: "Workshop on Public Speaking",
      date: "Date:8th September 2023",
      venue: "Venue:BBA,Nit Rourkela",
    },
    // {
    //   id: 2,
    //   src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1694004691/chayan_bbl2wk.jpg",
    //   speaker: "CHAYAN KUMAR PANT ",
    //   designation: "Public Speaker",
    //   workshop: "Workshop on Public Speaking",
    //   date: "Date:8th September 2023",
    //   venue: "Venue:BBA,Nit Rourkela",
    // },
    // {
    //   id: 3,
    //   src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1694004691/nitish_zx6hod.jpg",
    //   speaker: "NITIN KUMAR PRUSTY",
    //   designation: "Public Speaker",
    //   workshop: "Workshop on Public Speaking",
    //   date: "Date:8th September 2023",
    //   venue: "Venue:BBA,Nit Rourkela",
    // },
    // {
    //   id: 4,
    //   src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1694004692/krish_vt2y4j.jpg",
    //   speaker: "KRISHNESH NAYAK",
    //   designation: "Public Speaker",
    //   workshop: "Workshop on Public Speaking",
    //   date: "Date:8th September 2023",
    //   venue: "Venue:BBA,Nit Rourkela",
    // },
    // {
    //   id: 5,
    //   src: "",
    //   speaker: "DARSHAN SATPATHY ",
    //   designation: "Public Speaker",
    //   workshop: "Workshop on Public Speaking",
    //   date: "Date:8th September 2023",
    //   venue: "Venue:BBA,Nit Rourkela",
    // },
    // {
    //   id: 6,
    //   src: "",
    //   speaker: "Poonam Rath",
    //   designation: "Public Speaker",
    //   workshop: "Workshop on Save Soil",
    //   date: "Date:8th September 2023",
    //   venue: "Venue:BBA,Nit Rourkela",
    // },
  ];
  return (
    <div className=" empowerment bg-[#666666]  w-full min-h-screen relative ">
      {/* Category */}
      <div className=" pt-20 lg:pt-32 px-auto lg:pl-10 w-fit h-1/3 relative">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693936355/Group_5_1_zxx6dj.png"
          alt="music"
        ></img>
        <h1 className=" absolute text-outfit text-white text-3xl sm:text-7xl lg:text-8xl  font-black bottom-1 md:bottom-5 left-[12%] md:left-[10%] lg:left-20 tracking-widest">
          EMPOWERMENT
        </h1>
      </div>

      {/* Workshop Description */}

      {empower.map(({ id, src , speaker, designation, workshop, date, venue }) => (
        <div
          key={id}
          className="w-full h-1/3 sm:max-w-2xl lg:max-w-xl xl:max-w-3xl flex flex-col md:flex-row items-center justify-start text-outfit mt-10 mb-2 mx-auto xl:ml-10 "
        >
          <div className={`w-40 h-40 md:w-64 md:h-64 xl:w-80 xl:h-80 bg-[url('https://res.cloudinary.com/dkqxnquga/image/upload/v1694004691/jyoti_tsy305.jpg')] bg-no-repeat bg-cover rounded-full border-8 border-[#4D4D4D]  hover:scale-110 duration-150 `}></div>

          <div className=" text-center md:text-left text-white h-2/3  mt-6 md:ml-10 ">
            <h className="text-3xl md:text-6xl lg:text-4xl font-extrabold ">
              {speaker}
            </h>
            <h1 className="text-2xl md:text-5xl  lg:text-3xl font-bold ">
              {designation}
            </h1>
            <br />
            <div className="text-md md:text-2xl lg:text-xl font-semibold leading-none">
              <h1>{workshop}</h1>
              <h1>{date}</h1>
              <h1>{venue}</h1>
            </div>
          </div>
        </div>
      ))}

      {/* Category Image*/}
      <div className="  sm:ml-[10%]  lg:ml-[18%] xl:absolute xl:bottom-2 xl:right-0 ">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693940476/image_ybr4xu.png"
          alt="empowerment"
          width={650}
          height={650}
        ></img>
      </div>
    </div>
  );
}

export default Empowerment;
